import qs from 'qs';
import _toLower from 'lodash/toLower';
import _isEmpty from 'lodash/isEmpty';
import _get from 'lodash/get';
import {
  fetchGetJSONReqOpts,
  fetchGetJSONResHandler,
  getErrorStatusCode,
  getFetcherHeader
} from '../modules/ajio-fetch/utils';
import fetcher from '../modules/ajio-fetch';
import { showError, setApiErrorList } from './shared/HTTPError';
import { setAdditionalInfo, setSorts } from './shared/productsData';
import { setCurrentFacets, setDeliveryFacets } from './shared/facets';
import properties from '../modules/ajio-util/properties';
import { isServerRendering } from '../utils/pageInfo';
import isNode from '../modules/ajio-util/isNode';
import { getStoreName, gtmEventPush } from '../modules/ga/GTMdatalayer';
import { getHostName } from '../utils/sisUtils';
import { readCohortValueCookie, readCookie } from '../components/common/Cookie.js';
import { isRuntimeBannersUrlEnabled } from '../utils/banner';
import { getMicrocartData } from './addProductToCart';
import { getVariant } from '../refresh/organism/ABFeature/Feature.tsx';
import {
  getJioBannerListingUrl,
  jioAdsLandingBannersParser,
  cmsAndJioAdsBannersMapper
} from '../utils/jioAdsRelated';
import { cmsAndOsmosAdsBannersMapper } from '../utils/osmosUtils';
import { getVertexQueryParams } from '../refresh/utils/vertexUtils';
import { 
  getSearchExpFlags,   
  buildQuery,
  getDefaultQuery,
  buildQueryString,
  parseProductQueryString,
  parseFacets,
  stringifyFacets
} from '../utils/products';
import { navigationTypes, channels, platforms } from '../routes/views/Constants';
import { setNavigationType } from '../utils/NavigationRevamp';
import apiEndPoints from '../modules/ajio-util/endpoints';
import {
  getSearchFlags,
  getEnableLinkCohort,
  getPriorityDeliveryPhase2Flag,
  getPriorityDeliverySLPTagsConfig,
  getEnableFilterImprovement,
  getEnableFilterImprovementPhase2,
  getUserRelevancy
} from '../refresh/selectors/featureFlagsSelector';
import { FLEEK_STORE } from '../constants/constant';
import { showLoader, hideLoader } from './shared/loader';
import _size from 'lodash/size';
import {getAmplitudeVariantPayload,  getAmplitudeVariantFlag, getAmplitudeVariantPayloadMap, getAmplitudeExperimentVariant } from '../utils/amplitudeCommon';
import { sha256Hex } from '../utils/products';
import { getFyndNavigationType } from '../routes/views/utils/fyndNavigationUtils';

const endpoints = require('../modules/ajio-util/properties');
const queryUtil = require('../modules/ajio-util/query');

const url = properties.getProperty('apiUrl');

let cachedProxyAgent;
function getProxyAgent() {
  if (cachedProxyAgent) return cachedProxyAgent;
  if (!isNode()) {
    return undefined;
  }

  const env = _get(process, 'env.NODE_CONFIG_ENV', 'production');
  const envLower = env.toLowerCase();
  try {
    // Import the module dynamically to prevent webpack from bundling it
    const proxyModule = module.require('https-proxy-agent');
    const { HttpsProxyAgent } = proxyModule;
    if (envLower.includes('replica') || envLower.includes('uat52')) {
      cachedProxyAgent = new HttpsProxyAgent('http://lwproxy.jio.com:8080');
    } else if (envLower.includes('gcp')) {
      cachedProxyAgent = new HttpsProxyAgent('http://gcpprodproxy.jio.com:8080');
    }
  } catch (error) {
    return undefined;
  }
  return cachedProxyAgent;
}

// mobile navigation static bottom link
function fetchMyAccount() {
  if (!isNode()) {
    return fetcher('/api/home', fetchGetJSONReqOpts()).then(fetchGetJSONResHandler);
  }
  return Promise.resolve();
}

export function getMyAccountDetailsResponse(myaccount) {
  return {
    type: 'MYACCOUNT_DATA_SUCCESS',
    myaccount
  };
}
function getNavigationDetailsResponse(navigation) {
  return {
    type: 'NAVIGATION_DATA_SUCCESS',
    navigation
  };
}

export function getNavigationDetail(data) {
  return {
    type: 'FETCH_CATEGORY_NAVIGATION',
    newNavABEnabled: data?.newNavABEnabled
  }
}

function getNavigationDetailFailed() {
  return {
    type: 'FETCH_CATEGORY_NAVIGATION_FAILED'
  }
}

export function getMyAccountDetails() {
  return function(dispatch) {
    return fetchMyAccount()
      .then(json => {
        if (json) {
          dispatch(getMyAccountDetailsResponse(json));
        }
      })
      .catch(err => {
        const statusCode = getErrorStatusCode(err);
        dispatch(showError('home', statusCode));
      });
  };
}

// search
function fetchSearchURL(searchValue, ABFlagObj, brandCode, brandId) {
  let url;
  if (brandCode) {
    url = `/api/home/search/${searchValue}?brandPageCode=${brandCode}&brandPageId=${brandId}&SearchExperimentFlag=${JSON.stringify(ABFlagObj)}`;
  } else {
    url = `/api/home/search/${searchValue}?SearchExperimentFlag=${JSON.stringify(ABFlagObj)}`;
  }
  return fetcher(url, fetchGetJSONReqOpts());
}

function getSearchDetailsResponse(search, responseSource) {
  return {
    type: 'FETCH_SEARCH_DATA',
    search,
    responseSource
  };
}
function getSearchDetailsValidStatus(status) {
  return {
    type: 'FETCH_SEARCH_STATUS',
    status: true
  };
}

export function clearSearchDetailsResponse(search) {
  return {
    type: 'CLEAR_SEARCH_DATA'
  };
}

const validateSearchInput = (inputStr = '') => {
  if (typeof inputStr === 'string' && inputStr) {
    inputStr = inputStr.trim();
    const regex = /[a-z0-9]+/i;
    if (inputStr && regex.test(inputStr)) {
      return true;
    }
  }
  return false;
};

export function getSearchDetails(searchValue = '', sis = false, isKiosk = false, brandCode, brandId) {
  const store = getHostName();
  return function(dispatch, getState) {
    const isValidSearchInput = validateSearchInput(searchValue);
    if (!isValidSearchInput) {
      return dispatch(getSearchDetailsValidStatus(isValidSearchInput));
    }
    if (searchValue.length <= 2) {
      return dispatch(clearSearchDetailsResponse());
    }
    dispatch(clearSearchDetailsResponse());

    const states = getState();
    
    const flags = getAmplitudeVariantPayload('searchExpFlags',states, getSearchFlags(states));
    

    let ABFlagObj = (states?.flags?.amplitude_experiment_flag == 'ON') ? getAmplitudeVariantPayloadMap(flags, states) : getSearchExpFlags(flags);
    

    return fetchSearchURL(searchValue, ABFlagObj, brandCode, brandId)
      .then(fetchGetJSONResHandler)
      .then(json => {
        const { suggestions = [], responseSource = '' } = json;
        const storeName = getStoreName();
        const searchStore = ['ajio', 'luxe', 'ajiogram'].includes(storeName) ? storeName : 'ajio';
        if(store?.toLowerCase() === FLEEK_STORE.toLowerCase()){
          gtmEventPush({
            event: 'fleek_blp_search_interactions',
            event_category:'fleek blp interactions',
            search_term: searchValue,
            page_type: 'blp screen',
            page_name: 'blp screen'
          });
        }
        if (suggestions.length === 0 && store !== 'luxe') {
          gtmEventPush({
            event: 'search_finish',
            search_term: searchValue,
            error_message: 'No products',
            page_type: 'search',
            page_name: `Search Screen/${searchStore}`
          });
          gtmEventPush({
            event: 'zero_search_results',
            seach_term: searchValue,
            error_message: 'No Products found.',
            page_type: 'search',
            page_name: `Search Screen/${searchStore}`
          });
        }
        if (sis) {
          suggestions.push({
            url: `${endpoints.getProperty('parentUrl')}/search/?text=${searchValue}`,
            value: `Search ${searchValue} on AJIO`,
            absolutePath: true,
            sis: true,
            customClass: 'sis-search'
          });
        }
        dispatch(getSearchDetailsResponse(suggestions, responseSource));
      })
      .catch(err => {
        const statusCode = getErrorStatusCode(err);
        dispatch(showError('home', statusCode));
      });
  };
}
// banner
export function setProfileData(profile = {}) {
  return {
    type: 'SET_PROFILE_DATA',
    profile
  };
}
export function getBannerDetailsResponse(banner) {
  return {
    type: 'BANNER_DATA_SUCCESS',
    banner
  };
}
export function setPlpOnLandingResponse(data, noProductsForPriceFilter) {
  return {
    type: 'SET_PLP_ON_LANDING_DATA',
    data,
    noProductsForPriceFilter
  };
}

export function setPreviousSearchValues(values) {
  return {
    type: 'PREVIOUS_SEARCH_SOURCE',
    values
  };
}

export function setPageCategory(values) {
  return {
    type: 'SET_PAGE_CATEGORY',
    values
  };
}

export function updatePlpOnLandingResponse(data) {
  return {
    type: 'UPDATE_PLP_ON_LANDING_DATA',
    data
  };
}
export function setPlpOnLandingSource(data) {
  return {
    type: 'SET_PLP_ON_LANDING_SOURCE',
    data
  };
}
export function setPlpOnLandingBannerData(data) {
  return {
    type: 'SET_PLP_ON_LANDING_BANNER_DATA',
    data
  };
}
export function setSeoMetaData(values) {
  return {
    type: 'SET_SEO_METADATA',
    values
  };
}

export function getBannerDetails(request = {}, pageID) {
  const { headerInfo = {} } = request;
  return function(dispatch) {
    return fetcher(
      `${request.pathname}?${qs.stringify(request.query)}`,
      fetchGetJSONReqOpts({ headers: { ...headerInfo } })
    )
      .then(fetchGetJSONResHandler)
      .then(serviceRes => {
        if (serviceRes.metaElementData) {
          dispatch(setSeoMetaData({ metaElementData: serviceRes.metaElementData }));
          dispatch(setAdditionalInfo({ metaElementData: serviceRes.metaElementData }));
        }
        dispatch(getBannerDetailsResponse(serviceRes));
      })
      .catch(err => {
        const statusCode = getErrorStatusCode(err);
        // TODO-GA;
        dispatch(showError('home', statusCode));
      });
  };
}

// Function to extract the PLP_ON_LANDINGPAGE_WIDGET value
function checkForPlpOnLandingPageWidget(response) {
  const widgetTypeObject = {};
  if (response && Array.isArray(response)) {
    for (const slot of response) {
      if (slot?.component?.banners?.length > 0) {
        for (const banner of slot.component.banners) {
          if (banner?.bannerType === 'PLP_ON_LANDINGPAGE_WIDGET') {
            widgetTypeObject.plpFlag = true;
            widgetTypeObject.ctaSettings = banner?.ctaSettings || {};
            widgetTypeObject.isInfiniteScroll = banner?.isInfiniteScroll || false;
            widgetTypeObject.bannerData = banner || {};
            widgetTypeObject.rowNumber = response?.rowNumber;
            widgetTypeObject.heading = slot.component?.heading;
            const positionIndex = response?.indexOf?.(slot);
            if (positionIndex >= 0) {
              widgetTypeObject.position = positionIndex + 1;
            }

            if (banner?.curatedId) {
              widgetTypeObject.curatedId = banner.curatedId;
              widgetTypeObject.widgetLevel = banner?.widgetLevel;
              widgetTypeObject.isCurated = true;
            } else if (banner?.feedLogic) {
              widgetTypeObject.feedLogic = banner.feedLogic;
              widgetTypeObject.widgetLevel = banner?.widgetLevel;
              widgetTypeObject.isFeedLogic = true;
            }
            break;
          }
        }
      }
      // commenting this as there can be multiple PLP on Landing entries in CMS response
      // to render only the last PLP on Landing entry in case if isInfiniteScroll is true
      // if (widgetTypeObject.plpFlag) break;
    }
  }
  return widgetTypeObject;
}
async function getCuratedInfo(req, cid) {
  const headerInfo = getFetcherHeader(req);
  return fetcher(
    `${apiEndPoints.get('curatedPage')}?url=/s/${encodeURIComponent(cid)}`,
    fetchGetJSONReqOpts({ headers: { ...headerInfo } })
  )
    .then(fetchGetJSONResHandler)
    .then(serviceRes => {
      let { query = `relevance&curated=true&curatedid=${cid}`, urlLink = '83' } = serviceRes;
      if (query) {
        query = `query=${query}`;
      }
      return { query, urlLink };
    })
    .catch(err => {
      console.log(err);
    });
}

export function getBannerDetailsRuntime(request = {}, pageID) {
  const { headerInfo = {}, jioAdsLandingBannersFlag, customerUID='', updatedVisitorId='', isVertexCategoryEnabled=false, isVertexStoreScopeEnabled=true, isPLAEnabled=false, plaAdsEliminationDisabled=false, isPlpBannerOsmosEnabled=false, isLoggedIn, segmentAnonymousId='', osmosBannerAds = {} } = request;

  return async function(dispatch, getState) {
    const promiseArray = [getBannersRuntimeApi({ ...request, ...headerInfo })];

    if (osmosBannerAds?.home?.isEnabled) {
      promiseArray.push(
        fetchOsmosAds({
          ...request,
          ...headerInfo,
          osmosBannerUrl: apiEndPoints.get('bannerAdsOsmos')
        })
      );
    } else if (jioAdsLandingBannersFlag) {
      promiseArray.push(getJioAdsLandingBanners({ ...request, ...headerInfo }));
    }

    const states = getState();
    const { enablePDPhase2 = false, pdSLPTagsConfig = {}, postalCode = '' } = request;
    let enablePriorityDeliveryPhase2 =
      getPriorityDeliveryPhase2Flag(states?.flags) || enablePDPhase2;
    let priorityDeliverySLPTagsConfig =
      getPriorityDeliverySLPTagsConfig(states) || pdSLPTagsConfig;
    if (Object.keys(priorityDeliverySLPTagsConfig).length === 0) {
      priorityDeliverySLPTagsConfig = pdSLPTagsConfig;
    }
    const vertexQuery = { 
      vertexEnabled: isVertexCategoryEnabled,
      ...(updatedVisitorId && {visitorId: updatedVisitorId})
    };

    try {
      let bannerRespCombined;
      if (osmosBannerAds?.home?.isEnabled) {
        const [cmsBannersResp, osmosAdsLandingBannersResp = {}] = await Promise.all(promiseArray);
        bannerRespCombined = cmsAndOsmosAdsBannersMapper(
          cmsBannersResp,
          osmosAdsLandingBannersResp,
          request?.channel || ''
        );
      } else {
        const [cmsBannersResp, jioAdsLandingBannersResp = {}] = await Promise.all(promiseArray);
        bannerRespCombined = cmsAndJioAdsBannersMapper(cmsBannersResp, jioAdsLandingBannersResp);
      }

      if (bannerRespCombined?.data?.seo) {
        dispatch(setSeoMetaData({ metaElementData: bannerRespCombined.data.seo }));
        dispatch(setAdditionalInfo({ metaElementData: bannerRespCombined.data.seo }));
      }
      const slotsData = bannerRespCombined?.data?.page?.slots;
      const plpExists = checkForPlpOnLandingPageWidget(slotsData);

      if (plpExists.curatedId) {
        // const prodCuratedID = 'boys-denims-trousers';
        // const devCuratedID = 'uat-test-1-3823-77781';
        try {
          const curatedInfo = await getCuratedInfo(request, plpExists.curatedId);
          const { device: { client_type = '' } = {}, params: { cid1 = '' } = {} } = request;
          const curatedResQuery = queryUtil.parseSearch(curatedInfo?.query);
          const { bannerData = {}, rowNumber = '', heading = '', position = '' } = plpExists;

          // NOTE: FOR FILTER IMPROVEMENT
          const filterImprovementEnabled = getEnableFilterImprovement(states);
          const filterImprovementPhase2Enabled = getEnableFilterImprovementPhase2(states);
          const userRelevancy = getUserRelevancy(states?.flags);
          const catgoryApiEndpoint = (() => {
            if (filterImprovementEnabled && userRelevancy) {
              return 'personalisedCategory';
            }

            if (filterImprovementPhase2Enabled) {
              return 'categoryV7';
            }

            if (filterImprovementEnabled) {
              return 'categoryV6';
            }

            return 'categoryV4';
          })();

          if (curatedResQuery?.query) {
            const curatedQuery = parseProductQueryString(curatedResQuery.query) || {};
            const curatedQueryFacets = parseFacets(curatedQuery.facets);
            const reqQuery = parseProductQueryString(request.query.query) || {};
            const reqQueryFacets = parseFacets(reqQuery.facets);
            const facets = stringifyFacets({
              ...curatedQueryFacets,
              ...reqQueryFacets
            });
            const query = buildQuery(
              { ...request.query, ...curatedQuery, ...reqQuery, facets },
              { defaultQuery: getDefaultQuery() }
            );
            query.query = buildQueryString(['sortBy', 'facets'], query);
            let apiEndPoint = `${apiEndPoints.get(catgoryApiEndpoint)}/${
              curatedInfo.urlLink
            }?${qs.stringify({
              ...query,
              curated: 'true',
              curatedid: curatedResQuery.curatedid,
              advfilter: true,
              displayRatings: true,
              client_type: client_type || 'MSITE',
              pageSize: 20,
              encryptedUserId: isLoggedIn ? sha256Hex(customerUID) : sha256Hex(segmentAnonymousId),
              ...(isVertexCategoryEnabled && { ...vertexQuery }),
            })}`;

            if (enablePriorityDeliveryPhase2 && postalCode && !apiEndPoint.includes('pincode=')) {
              apiEndPoint = `${apiEndPoint}&pincode=${postalCode}`;
            }

            const requestHeader = { headers: { ...headerInfo } };
            if (apiEndPoint.includes('allfilters=true')) {
              requestHeader.timeout = 30000;
            }
            const response = await fetcher(apiEndPoint, fetchGetJSONReqOpts(requestHeader));
            const json = await fetchGetJSONResHandler(response);
            if (json) {
              const { facets = [], ...responseWithoutFacets } = json;
              const {
                products = {},
                isSlaNodesAvailable = false,
                pagination = {},
                sorts = [],
                isAdvanceFacetsEnabled,
                responseSource= 'Saas',
                attributionToken='',
                pageCategory=''
              } = responseWithoutFacets || {};
              const { totalResults = _size(products) } = pagination;
                     
              if (isNode()) {
                dispatch(setPreviousSearchValues(responseSource));
                dispatch(setPageCategory(pageCategory));
                attributionToken && dispatch(setAdditionalInfo({ attributionToken, metaElementData: bannerRespCombined?.data?.seo }));
              }

              const {
                disabledDeliveryFacets = null,
                isPriorityDeliveryOffered = false
              } = await setDeliveryFacets(
                facets,
                isSlaNodesAvailable,
                enablePriorityDeliveryPhase2,
                priorityDeliverySLPTagsConfig
              );
              const updatedFacets = disabledDeliveryFacets
                ? [...facets, disabledDeliveryFacets]
                : facets;

              dispatch(
                setPlpOnLandingResponse({
                  ...responseWithoutFacets,
                  facets: updatedFacets,
                  curatedid: plpExists.curatedId,
                  heading
                })
              );
              dispatch(setPlpOnLandingSource('curated'));
              dispatch(setPlpOnLandingBannerData({ ...bannerData, rowNumber, heading, position }));
              if (sorts.length > 0) {
                dispatch(setSorts(sorts));
              }
              if (updatedFacets.length > 0) {
                dispatch(
                  setCurrentFacets(
                    updatedFacets,
                    totalResults,
                    isAdvanceFacetsEnabled,
                    query,
                    isPriorityDeliveryOffered,
                    enablePriorityDeliveryPhase2
                  )
                );
              }
            } else {
              console.error('No data received from API.');
            }
          }
        } catch (error) {
          console.error('Error fetching curated info:', error);
        }
      } // change to elseif plpExists.feedLogic
      if (plpExists.feedLogic) {
          const { feedLogic = 'w1' } = plpExists?.feedLogic || {};
          const {
            widgetLevel = plpExists?.widgetLevel || 'PLATFORM',
            enableAdsOnPlp,
            noOfProducts,
            showViewAllWidget,
            platform,
            widgetName,
            showDefault
          } = request?.query;

          const isWidgetIncludedVertex = widgetLevel.toLowerCase() !== 'user';
          const headerInfo = getFetcherHeader(request);
          let storeval = request.runtimeParams.store.toLowerCase() || request.store; // || StoreValue;
          if (!storeval || storeval === '') storeval = 'rilfnl';
          const newIn = false;
          const fields = 'SITE';
          const query = ':relevance';
          const isOfferPriceABEnabled = getVariant('offerPrice');
          const dynamicWidgetRilWebServiceUrl = isVertexCategoryEnabled ? '/rilfnlwebservices/v2/rilfnl/' : '/rilfnlwebservices/rilfnl/';
          const userLevelWidgetParams = {};
          let showDefaultIfNoData = false;
          const { CI: userId, A: token } = request?.cookies || {};
          const enablePriorityDeliveryPhase2 = true;
          const { cookies: { PC = '', LS='', ZN='', ST='', CT='', customerType='', segment_device_id='' } = {} } = request;
          const userState = LS === 'LOGGED_IN' ? 'LOGGED_IN' : 'NON_LOGGED_IN';
        const encryptedUserId = isLoggedIn ? sha256Hex(customerUID) : sha256Hex(segmentAnonymousId);

          const isAjioStore = ['', 'ajio', 'rilfnl'].includes(storeval ?? '');
          if (isAjioStore) storeval = 'ajio';
          const widgetVertexQueryParams = getVertexQueryParams(
            states,
            storeval,
            '',
            updatedVisitorId,
          encryptedUserId,
            'browse'
          );
          const apiEndPoint = `${url}${dynamicWidgetRilWebServiceUrl}products/widgets/83?${qs.stringify(
            {
              newin: newIn,
              pageSize: 20,
              fields,
              store: storeval,
              offer_price_ab_enabled: isOfferPriceABEnabled,
              is_ads_enable_plp: enableAdsOnPlp,
              plaAdsProvider: isPLAEnabled ? 'OSMOS': 'JIOADS',
              plaAdsEliminationDisabled,
              plpBannerAdsEnabled: isPlpBannerOsmosEnabled,
              platform,
              query,
              widgetID: feedLogic, // change at TOC
              widgetType: widgetLevel,
              widgetName,
              widgetMinProdCount: noOfProducts,
              showViewAllWidget: true,
              ...userLevelWidgetParams,
              ...(isVertexCategoryEnabled && isAjioStore && { ...vertexQuery }),
              ...(isAjioStore && (isVertexCategoryEnabled || isPLAEnabled) && {encryptedUserId: LS === 'LOGGED_IN' ? sha256Hex(customerUID): sha256Hex(segment_device_id)}),
              ...widgetVertexQueryParams,
              zone: ZN,
              state: ST,
              city: CT,
              userRestriction: customerType,
              userState
            }
          )}`;
        fetcher(apiEndPoint, fetchGetJSONReqOpts({ headers: { ...headerInfo } }))
          .then(response => {
            return fetchGetJSONResHandler(response);
          })
          .then(json => {
            if (json) {
              dispatch(setPlpOnLandingResponse(json));
              dispatch(setPlpOnLandingSource('feedlogic'));
            }
          })
          .catch(err => {
            console.log(err, '---err');
          });
      }

      dispatch(getBannerDetailsResponse(bannerRespCombined));
    } catch (err) {
      const statusCode = getErrorStatusCode(err);
      // TODO-GA;
      dispatch(showError('home', statusCode));
    }
  };
}

export function getBannerDetailsRuntimePreviewOrArchive(request = {}, pathname) {
  return async function(dispatch) {
    const {
      headerInfo = {},
      jioAdsLandingPagesExperiment = '',
      landingPagesExperiments = [],
      jioAdsLandingBannersFBFlag,
      jioAdsSpecszz: { bufferTimeForPreview = 10 } = {},
      query: { timeStamp = '' } = {},
      osmosBannerAds = {}
    } = request;

    const isNewCmsPreview = request.runtimeParams.pageUrl === '/shop/newCMSPreview';
    request.pathname = pathname;
    if (request.runtimeParams.pageUrl === '/shop/newCMSPreview') {
      delete request.runtimeParams.pageUrl;
    } else {
      delete request.runtimeParams.pageId;
    }

    const timeStampFromCMS =
      _isEmpty(timeStamp) || timeStamp === 'undefined' ? new Date() : new Date(timeStamp);
    const currentTime = new Date();
    const diffBWTimeInSecs = Math.abs((timeStampFromCMS - currentTime) / 1000);
    const jioAdsBufferLimit = bufferTimeForPreview * 60;
    const limitThresholdCrossed = jioAdsBufferLimit < diffBWTimeInSecs;

    // jio ads banner experiment setup is available to preview
    const jioAdsEnabled =
      landingPagesExperiments.includes(jioAdsLandingPagesExperiment) &&
      jioAdsLandingBannersFBFlag === 'ON' &&
      !limitThresholdCrossed;
    const requestPayload = {
      ...request,
      runtimeParams: {
        ...request.runtimeParams,
        experiments: landingPagesExperiments
      }
    };
    const promiseArray = [getBannersRuntimeApi({ ...requestPayload, ...headerInfo })];

    if (osmosBannerAds?.home?.isEnabled) {
      promiseArray.push(
        fetchOsmosAds({
          ...request,
          ...headerInfo,
          osmosBannerUrl: apiEndPoints.get('bannerAdsOsmos')
        })
      );
    } else if (jioAdsEnabled && !isNewCmsPreview) {
      promiseArray.push(getJioAdsLandingBanners({ ...request, ...headerInfo }));
    }

    try {
      let bannerRespCombined;
      if (osmosBannerAds?.home?.isEnabled) {
        const [cmsBannersResp, osmosAdsLandingBannersResp = {}] = await Promise.all(promiseArray);
        bannerRespCombined = cmsAndOsmosAdsBannersMapper(
          cmsBannersResp,
          osmosAdsLandingBannersResp,
          request?.channel || ''
        );
      } else {
        const [cmsBannersResp, jioAdsLandingBannersResp = {}] = await Promise.all(promiseArray);
        bannerRespCombined = cmsAndJioAdsBannersMapper(cmsBannersResp, jioAdsLandingBannersResp);
      }

      if (bannerRespCombined?.data?.seo) {
        dispatch(setSeoMetaData({ metaElementData: bannerRespCombined.data.seo }));
        dispatch(setAdditionalInfo({ metaElementData: bannerRespCombined.data.seo }));
      }

      dispatch(getBannerDetailsResponse(bannerRespCombined));
    } catch (err) {
      const statusCode = getErrorStatusCode(err);
      // TODO-GA;
      dispatch(showError('home', statusCode));
    }
  };
}

export function getRuntimeBanners(postalCode = {}) {
  return function(dispatch, getState) {
    dispatch(showLoader('address-loader'));
    const path = window.location.pathname.split('/');
    const {
      city,
      state,
      zone,
      pincodeGroup,
      userGroup,
      enableClusterFeatureHome,
      enableEarlyAccessFlag,
      enableEarlyAccessBannerCategoryFlag = false,
      pageUrl,
      storeName,
      searchPage,
      pageType = ''
    } = postalCode;

    const states = getState();
    const landingPagesExperiments = getAmplitudeVariantPayload('landingPagesExperiments', states, states?.flags?.landingPagesExperiments || []);
    const jioAdsLandingPagesExperiment = getAmplitudeVariantPayload('jioAdsLandingPagesExperiment', states, states?.flags?.jioAdsLandingPagesExperiment || '');  
    const jioAdsLandingBannersFlag =
      getAmplitudeVariantPayload(
        'jioadslandingbannersflag',
        states,
        states?.flags?.jioAdsLandingBannersFlag || 'OFF'
      ) === 'ON';
    const getBannerExperiments = [];
    const enableUniversalCohortFlow = getAmplitudeVariantPayload('enableUniversalCohortFlow', states, false);

    let jioAdsEnabled = false;
    for (const experiment of landingPagesExperiments) {
      const experimentVariant = getAmplitudeVariantFlag(experiment ,states ,getVariant(experiment));
      if (experimentVariant) {
        getBannerExperiments.push(experiment);
      }
    }    
    if (
      landingPagesExperiments.includes(jioAdsLandingPagesExperiment) &&
      getAmplitudeVariantFlag(jioAdsLandingPagesExperiment, states , getVariant(jioAdsLandingPagesExperiment)) &&
      jioAdsLandingBannersFlag
    ) {
      jioAdsEnabled = true;
    }

    let { customerType = '' } = postalCode;
    customerType = customerType.trim();
    if (!customerType || customerType.toLocaleLowerCase() === 'undefined') {
      let customerData = sessionStorage.getItem('customerTypeData') || '{}';
      customerData = JSON.parse(customerData);
      customerType = customerData?.customerType ?? '';
    }
    let cohortValue = userGroup;
    let jioAdsCustomerType = cohortValue || '';
    if(!cohortValue){
      //deviceId cohort
      cohortValue = readCohortValueCookie('deviceCohortValue', storeName, 'cms', enableUniversalCohortFlow);
    }
    const linkCohort = readCookie('linkCohort');
    const hasAjioStore =
      String(storeName).toLowerCase() === 'ajio' || String(storeName).toLowerCase() === 'rilfnl' || storeName === '';
    const enableLinkCohort = getEnableLinkCohort(states?.flags) == 'ON';
    if (enableLinkCohort && hasAjioStore && !cohortValue && linkCohort) {
      cohortValue = linkCohort;
      jioAdsCustomerType = cohortValue;
    }
    const userGroupQuey =
      enableClusterFeatureHome && cohortValue ? `&userGroup=${cohortValue}&jioAdsCustomerType=${jioAdsCustomerType}` : '';
    // const userGroupQuey = userGroup ? `&userGroup=${userGroup}` : '';
    let catstr = path[path.length - 1] || storeName;

    if (pageUrl) {
      const url = pageUrl.split('/');
      catstr = url[url.length - 1];
    }
    return fetcher(
      `/api/banner/getBanners?catstr=${catstr}&city=${city}&state=${state}&zone=${zone}&pincodeGroup=${pincodeGroup}&customerType=${customerType}${userGroupQuey}&pageType=${pageType}&experiments=${getBannerExperiments.join()}&jioAdsEnabled=${jioAdsEnabled}`,
      fetchGetJSONReqOpts()
    )
      .then(fetchGetJSONResHandler)
      .then(({ profileResponse, serviceRes }) => {
        dispatch(setProfileData(profileResponse));
        dispatch(getBannerDetailsResponse(serviceRes));
        dispatch(hideLoader("address-loader"));
      })
      .catch(err => {
        dispatch(hideLoader("address-loader"));
        console.log(err);
      });
  };
}

export function cartWishlistCount(counts) {
  return {
    type: 'CART_WISHLIST_COUNT',
    counts
  };
}

// Cart and Wishlist count
export function getCartWishlistCounts() {
  return getMicrocartData();
}

export function getCartWishlistCount() {
  return {
    type: 'CART_WISHLIST_COUNT',
    counts: {
      cartCount: 0,
      wishlistCount: 0
    }
  };
}

export function fetchTopSearches() {
  return function(dispatch) {
    return fetcher('/api/home/topSearches', fetchGetJSONReqOpts())
      .then(fetchGetJSONResHandler)
      .then(serviceRes => {
        const { suggestions = [] } = serviceRes;
        dispatch({
          type: 'FETCH_TOP_SEARCHES_SUCCESSFULL',
          topSearches: suggestions
        });
      })
      .catch(err => {});
  };
}

export function getIsRuntimeBannerPage(details, pageUrl) {
  const {
    storeName,
    runtimeBanners,
    runtimeBannersSis,
    runtimeBannersUrlListMsiteSis,
    runtimeBannersUrlListMsite
  } = details;
  const hasStore = storeName && storeName.toUpperCase() !== 'AJIO';
  const isRuntimeBannerPage =
    (!hasStore &&
      runtimeBanners &&
      isRuntimeBannersUrlEnabled(runtimeBannersUrlListMsite, pageUrl)) ||
    (hasStore &&
      runtimeBannersSis &&
      isRuntimeBannersUrlEnabled(runtimeBannersUrlListMsiteSis, pageUrl));

  return isRuntimeBannerPage;
}

async function getBannersRuntimeApi(payload) {
  console.log("🚀 ~ getBannersRuntimeApi ~ payload:", payload?.runtimeParams)
  const responseStream = await fetcher(
    payload.pathname,
    fetchGetJSONReqOpts({
      body: JSON.stringify(payload.runtimeParams),
      method: 'POST',
      headers: {
        'content-type': 'application/json',
        ...payload.headerInfo
      },
      credentials: 'include'
    })
  );

  try {
    const resp = await fetchGetJSONResHandler(responseStream);
    return resp;
  } catch (error) {
    return {};
  }
}
function getSecondaryCohort(userCohortValue){
  if(typeof userCohortValue !== 'string'){
    return ''
  }
  const secondaryCohorts = userCohortValue.split('|')[1]
  if(secondaryCohorts){
    const regex = /[^a-zA-Z0-9,_]/g;
    // Replace all matched characters with underscores.
    return secondaryCohorts.replace(regex, "_");
  }

  return '';
}
async function getJioAdsLandingBanners(payload) {
  const { runtimeParams = {}, jioAdsSpecs = {} } = payload;
  const { pageUrl = '' } = runtimeParams;
  const page_url = pageUrl.replace('/shop/', '').replace('-', '_');

  const jioAdsURL = getJioBannerListingUrl({
    isLandingAdBanners: true,
    adSpotId: _toLower(jioAdsSpecs?.adSpotId),
    md_ajiocat: '',
    ua: _toLower(payload?.userAgent),
    md_utype: _toLower(payload?.customerValueType),
    md_sis: _toLower(runtimeParams?.store),
    os: _toLower(payload?.os),
    ai: _toLower(payload?.ai),
    vr: _toLower(payload?.vr),
    ifa: _toLower(payload?.ifa),
    md_user_status: _toLower(runtimeParams?.userStatus) || 'non_logged_in',
    md_user_restriction: _toLower(runtimeParams?.userType) || 'new',
    vnm: 'jioads',
    md_platform: _toLower(payload?.platform),
    md_channel: _toLower(payload?.channel),
    md_page_url: _toLower(page_url),
    md_secondaryid: getSecondaryCohort(payload.userGroup)
  });
  try {
    const dataPromise = fetcher(jioAdsURL.href, fetchGetJSONReqOpts({
        method: 'GET',
      })
);
    const responseStream = await Promise.race([dataPromise, timeout(jioAdsSpecs.apiTimeoutLimit)]);
    if (responseStream?.timedOut) {
      console.log('jio ads api timeout');
      return {};
    }
    const resp = await jioAdsLandingBannersParser(
      await fetchGetJSONResHandler(responseStream),
      jioAdsSpecs?.adSpotId
    );
    return resp;
  } catch (error) {
    return {};
  }
}

export function getCategoriesDetail(storeName='', newNavigationEnabled=true) {
  const apiName = `${apiEndPoints.get('runtimeNavigationDesktop')}`;
  let platform = platforms.MOBILE
  let channel =  channels.MSITE
  let navigationType = setNavigationType(navigationTypes.CATEGORIES,storeName,'true')
  const data = JSON.stringify({
    channel,
    navigationType,
    platform,
    store: storeName.toUpperCase(),
    tenantId: 'AJIO'
  });

  return function(dispatch, getState) {
    dispatch(getNavigationDetail({ newNavABEnabled: newNavigationEnabled }));
    const states = getState();
    const webNavigationFlag = getAmplitudeVariantPayload('web_navigations', states, {});
    const fyndNavigationType = getFyndNavigationType(
      webNavigationFlag,
      navigationType,
      storeName.toUpperCase()
    );
    return fetcher(
      apiName,
      fetchGetJSONReqOpts({
        method: 'POST',
        body: { ...data, navigationType: fyndNavigationType },
        headers: { 'content-type': 'application/json' },
      })
    )
      .then(response => {
      if (response.ok) {
        return response.json();
      }
    }).then(json => {
        if (json) {
          dispatch(getNavigationDetailsResponse(json));
        }
      })
      .catch(err => {
        const statusCode = getErrorStatusCode(err);
        dispatch(showError('navigationMobile', statusCode));
        dispatch(setApiErrorList('CATEGORIES'));
        dispatch(getNavigationDetailFailed());
      });
  };
}
function timeout(ms = 5000) {
  return new Promise(resolve => setTimeout(() => resolve({ timedOut: true }), ms));
}

function getOsmosBannerUrl(urlParams) {
  const {
    baseUrl = '',
    sis = 'ajio',
    pageType = '',
    pincode = '',
    userType = 'Existing',
    state = '',
    clientId = '',
    userSecondaryCohort = '',
    cliUbid = '',
    userLoginStatus = 'LOGGED_IN',
    pcntAu = 10,
    platform = 'MOBILE',
    userCohort = '',
    zone = '',
    channel = 'Android',
    city = ''
  } = urlParams;

  const osmosAdsURL = new URL(baseUrl);
    osmosAdsURL.searchParams.set('f.sis', sis);
  if (pageType) osmosAdsURL.searchParams.set('pt', pageType.replace(/[^a-zA-Z0-9]/g, '_'));
  if (pincode) osmosAdsURL.searchParams.set('f.pincode', pincode);
  if (userType) osmosAdsURL.searchParams.set('f.user_type', JSON.stringify([userType]));
  if (state) osmosAdsURL.searchParams.set('f.state', JSON.stringify([state]));
  if (clientId) osmosAdsURL.searchParams.set('client_id', clientId);
  if (userSecondaryCohort)
    osmosAdsURL.searchParams.set('f.user_secondary_cohort', JSON.stringify([userSecondaryCohort]));
  if (cliUbid) osmosAdsURL.searchParams.set('cli_ubid', cliUbid);
  if (userLoginStatus) osmosAdsURL.searchParams.set('f.user_loginstatus', JSON.stringify([userLoginStatus]));
  if (pcntAu) osmosAdsURL.searchParams.set('pcnt_au', pcntAu);
  if (platform) osmosAdsURL.searchParams.set('f.platform', platform);
  if (userCohort) osmosAdsURL.searchParams.set('f.user_cohort', JSON.stringify([userCohort]));
  if (zone) osmosAdsURL.searchParams.set('f.zone', zone);
  osmosAdsURL.searchParams.set('rn', Date.now());
  if (channel) osmosAdsURL.searchParams.set('f.channel', JSON.stringify([channel]));
  if (city) osmosAdsURL.searchParams.set('f.city', JSON.stringify([city]));


  return osmosAdsURL;
}


function signInCheck(getUserId = false) {
  let user;
  let signedIn;
  try {
    user = readCookie('un');
    signedIn = readCookie('U');
  } catch (error) {
    console.log(`Failed to read cookie : ${error}`);
  }
  let username = '';
  if (signedIn && signedIn !== 'anonymous') {
    // sI not being able to read. but can read un?
    // username = this.props.userName; //store is getting empty
    username = getUserId ? decodeURIComponent(signedIn) : decodeURIComponent(user); // store is getting empty so reading from cookie - think of alt
  }
  return username;
}

async function fetchOsmosAds(payload) {
  try {
    const { osmosAdsSpecs, osmosBannerUrl, runtimeParams = {}, enableUniversalCohortFlow = false } = payload;
    const { pageUrl = '' } = runtimeParams;
    const page_url = pageUrl.replace(/[^a-zA-Z0-9]/g, '_');
    const secondaryCohort = getSecondaryCohort(payload.userGroup) || '';
    const { PC: pincode = '', ST: state = '', ZN: zone = '' } = payload?.cookies || {};
    const clientId = osmosAdsSpecs?.clientId || '';
    const cliUbid = signInCheck() ? sha256Hex(readCookie('CI')) || '' : sha256Hex(readCookie('segment_device_id')) || '';
    const userCohort = readCohortValueCookie('userCohortValues', runtimeParams.store, 'cms', enableUniversalCohortFlow);

    const osmosAdsURL = getOsmosBannerUrl({
      baseUrl: osmosBannerUrl,
      sis: runtimeParams.store,
      pageType: page_url,
      pincode: pincode,
      userType: runtimeParams.userType,
      state: state,
      clientId: clientId,
      userSecondaryCohort: secondaryCohort || 'nogender',
      cliUbid: cliUbid,
      userLoginStatus: runtimeParams.userStatus,
      pcntAu: osmosAdsSpecs?.pcntAu || 10,
      platform: runtimeParams?.platform,
      userCohort: userCohort,
      zone: zone,
      channel: runtimeParams?.channel,
      city: runtimeParams?.city
    });

    const proxyAgent = getProxyAgent() || undefined;
    const osmosAdsResponse = await Promise.race([
      fetcher(
        osmosAdsURL.href,
        fetchGetJSONReqOpts({
          method: 'GET',
          ...(proxyAgent ? { agent: proxyAgent } : {})
        })
      ),
      timeout(osmosAdsSpecs.apiTimeoutLimit || 1000)
    ]);

    if (osmosAdsResponse?.timedOut) {
      throw new Error('Osmos Ads API request timed out');
    }
    const resp = await fetchGetJSONResHandler(osmosAdsResponse);
    return resp;
  } catch (err) {
    console.error('Failed to fetch Osmos Ads:', err);
    return [];
  }
}
